import router from "../routes";

export const handleApiError = (error) => {
  const data = error.response?.data;
  let message = data?.message || "An error occurred";
  const fieldErrors =
    data?.errors && typeof data.errors === "object" ? data.errors : null;

  if (fieldErrors) {
    const validationMessages = Object.values(fieldErrors).flat().filter(Boolean);
    if (validationMessages.length) {
      message = validationMessages.join(" ");
    }
  }

  const normalizedError = new Error(message);
  normalizedError.fieldErrors = fieldErrors;
  normalizedError.statusCode = error.response?.status;
  return normalizedError;
};

export const reloadRoute = (newQuery) => {
  const currentQuery = router.currentRoute.query;

  const isSameQuery =
  Object.keys(newQuery).length === Object.keys(currentQuery).length &&
  Object.keys(newQuery).every((key) => newQuery[key] === currentQuery[key]);

  if (!isSameQuery) {
    router.replace({ query: newQuery });
  }
};

export const getClientIp = async () => {
  try {
    const res = await fetch("https://api.ipify.org?format=json");
    if (!res.ok) console.error("Error fetching client IP");
    const { ip } = await res.json();
    return ip;
  } catch (error) {
    console.error("Error fetching client IP:", error);
    return null;
  }
};

export const getClientCountryCode = async (ip = "") => {
  if (!ip) ip = await getClientIp();
  if (!ip) return null;
  try {
    const res = await fetch(`https://api.iplocation.net/?ip=${ip}`);
    if (!res.ok) {
      console.error("Error fetching client country");
    }
    const { country_code2: code } = await res.json();
    return code || null;
  } catch (error) {
    console.error("Error fetching client country:", error);
    return null;
  }
};

export const getLocaleCountryCode = () => {
  try {
    const locales = navigator.languages?.length ? navigator.languages : [navigator.language];
    for (const locale of locales) {
      if (!locale) continue;
      const parts = locale.split("-");
      if (parts.length >= 2) {
        return parts[parts.length - 1].toUpperCase();
      }
    }
  } catch (error) {
    console.error("Error reading browser locale country:", error);
  }
  return null;
};

export const getDefaultPhoneCountryCode = async () => {
  const fromIp = await getClientCountryCode();
  if (fromIp) return fromIp;

  const fromLocale = getLocaleCountryCode();
  if (fromLocale) return fromLocale;

  return "AT";
};

export const formatAddressText = (address) => {
  if (!address) return [];

  return address
    .split(",")
    .map(item => item.trim())
    .filter(Boolean)
    .join(", ");
};